module.exports = __webpack_public_path__ + "media/venue/conferences@3x-71491c76.png";